import React, { useMemo } from 'react';
import { Layer, Line, Text, Arc, Shape } from 'react-konva';
import { P } from '../../model/constants';
import { useMapStore } from '../../model/stores/mapStore';

const BuildingLayer = React.memo(({ x, y, scaleX, scaleY }: {
  x: number; y: number; scaleX: number; scaleY: number;
}) => {
  const rooms = useMapStore((s) => s.rooms);
  const walls = useMapStore((s) => s.walls);

  const roomShapes = useMemo(() =>
    rooms.map((room) => {
      const xs = room.pts.filter((_, i) => i % 2 === 0);
      const ys = room.pts.filter((_, i) => i % 2 === 1);
      const cx = (Math.min(...xs) + Math.max(...xs)) / 2 * P - 40;
      const cy = (Math.min(...ys) + Math.max(...ys)) / 2 * P - 6;
      return { room, cx, cy };
    }), [rooms]);

  const wallShapes = useMemo(() =>
    walls.map((wall, i) => {
      const x1 = wall.f[0] * P, y1 = wall.f[1] * P;
      const x2 = wall.t[0] * P, y2 = wall.t[1] * P;
      return { wall, x1, y1, x2, y2, key: i };
    }), [walls]);

  return (
    <Layer x={x} y={y} scaleX={scaleX} scaleY={scaleY}>
      {/* Raumflächen */}
      {roomShapes.map(({ room, cx, cy }) => (
        <React.Fragment key={room.label}>
          <Line
            points={room.pts.map(v => v * P)}
            closed
            fill={room.fill}
            stroke="transparent"
          />
          <Text
            x={cx} y={cy}
            width={80}
            text={room.label}
            fontSize={11}
            fill="rgba(255,255,255,0.35)"
            align="center"
          />
        </React.Fragment>
      ))}

      {/* Wände, Shared-Wände, Türen */}
      {wallShapes.map(({ wall, x1, y1, x2, y2, key }) => {
        if (wall.type === 'door') {
          const len = Math.hypot(x2 - x1, y2 - y1);
          return (
            <React.Fragment key={key}>
              <Line points={[x1, y1, x2, y2]} stroke="rgba(255,255,255,0.25)" strokeWidth={2} dash={[5, 3]} />
              <Arc
                x={x1} y={y1}
                innerRadius={0}
                outerRadius={len}
                angle={90}
                rotation={y1 === y2 ? -90 : 0}
                fill="rgba(255,255,255,0.04)"
              />
            </React.Fragment>
          );
        }
        if (wall.type === 'shared') {
          return (
            <Shape
              key={key}
              sceneFunc={(ctx, shape) => {
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.strokeShape(shape);
              }}
              stroke="rgba(255,255,255,0.1)"
              strokeWidth={2}
              lineCap="round"
            />
          );
        }
        return (
          <Line key={key} points={[x1, y1, x2, y2]} stroke="#0d0d0d" strokeWidth={6} lineCap="round" />
        );
      })}
    </Layer>
  );
});

BuildingLayer.displayName = 'BuildingLayer';
export default BuildingLayer;
